import React from 'react';
import { motion } from 'framer-motion';
export function PremiumGallery() {
  // 18 images for the gallery
  const images = [
  // desayunos
  'https://images.unsplash.com/photo-1484723091739-30a097e8f929?auto=format&fit=crop&q=80&w=600&h=600', 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&q=80&w=600&h=600',
  // budín saludable de banana (reemplaza la taza de café)
  'https://images.unsplash.com/photo-1606101273945-e9eba91c0dc4?auto=format&fit=crop&q=80&w=600&h=600',
  // almuerzos
  'https://images.unsplash.com/photo-1467003909585-2f8a72700288?auto=format&fit=crop&q=80&w=600&h=600', 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&q=80&w=600&h=600', 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&q=80&w=600&h=600',
  // meriendas / postres
  'https://images.unsplash.com/photo-1488477181946-6428a0291777?auto=format&fit=crop&q=80&w=600&h=600', 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?auto=format&fit=crop&q=80&w=600&h=600', 'https://images.unsplash.com/photo-1551024601-bec78aea704b?auto=format&fit=crop&q=80&w=600&h=600',
  // bowls
  'https://images.unsplash.com/photo-1512058564366-18510be2db19?auto=format&fit=crop&q=80&w=600&h=600', 'https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&q=80&w=600&h=600', 'https://images.unsplash.com/photo-1543339308-43e59d6b73a6?auto=format&fit=crop&q=80&w=600&h=600',
  // batidos
  'https://images.unsplash.com/photo-1502741224143-90386d7f8c82?auto=format&fit=crop&q=80&w=600&h=600', 'https://images.unsplash.com/photo-1553530666-ba11a7da3888?auto=format&fit=crop&q=80&w=600&h=600', 'https://images.unsplash.com/photo-1505252585461-04db1eb84625?auto=format&fit=crop&q=80&w=600&h=600',
  // ensaladas
  'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&q=80&w=600&h=600', 'https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&q=80&w=600&h=600', 'https://images.unsplash.com/photo-1482049016688-2d3e1b311543?auto=format&fit=crop&q=80&w=600&h=600'];
  return <section className="py-24 bg-cream overflow-hidden" data-id="element-683">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16 text-center" data-id="element-684">
        <h2 className="text-3xl md:text-4xl font-bold text-ink mb-4 tracking-tight" data-id="element-685">
          Platos que vas a disfrutar
        </h2>
        <p className="text-lg text-ink-light max-w-2xl mx-auto" data-id="element-686">
          Desayunos, almuerzos, meriendas, postres, bowls, batidos y ensaladas.
          Todo diseñado para que comer sano sea un placer.
        </p>
      </div>

      <div className="flex flex-col gap-4" data-id="element-687">
        {/* Row 1 - Moving Left */}
        <div className="flex gap-4 w-max animate-marquee" data-id="element-688">
          {[...images.slice(0, 9), ...images.slice(0, 9)].map((img, i) => <div key={i} className="w-64 h-64 md:w-80 md:h-80 rounded-3xl overflow-hidden flex-shrink-0 shadow-sm" data-id="element-689">
              <img src={img} alt="Receta" className="w-full h-full object-cover hover:scale-110 transition-transform duration-700" data-id="element-690" />
            </div>)}
        </div>

        {/* Row 2 - Moving Right */}
        <div className="flex gap-4 w-max animate-marquee" style={{
        animationDirection: 'reverse'
      }} data-id="element-691">
          {[...images.slice(9, 18), ...images.slice(9, 18)].map((img, i) => <div key={i} className="w-64 h-64 md:w-80 md:h-80 rounded-3xl overflow-hidden flex-shrink-0 shadow-sm" data-id="element-692">
              <img src={img} alt="Receta" className="w-full h-full object-cover hover:scale-110 transition-transform duration-700" data-id="element-693" />
            </div>)}
        </div>
      </div>
    </section>;
}